
<template>
  <div id="AboutSupsis">
    <div class="title-text fade-in">
      <h1>{{ $t("aiExpectationsTitle") }}</h1>
    </div>
    <div class="content">
      <div class="about-form">
        <div class="form-now">
          <div
              v-for="(optionKey, index) in optionKeys"
              :key="optionKey"
              class="card slide-in"
              :class="{
                        disabled: optionKey !== 'endToEndSolution' && options.endToEndSolution,
                        'selected': options[optionKey]
                    }"
              :style="`animation-delay: ${index * 0.3}s`"
              @click="toggleCheckbox(optionKey)"
          >
            <label class="check-box" @click.stop="toggleCheckbox(optionKey)">
              <input
                  type="checkbox"
                  :checked="options[optionKey]"
                  hidden
              >
              <span class="checkmark" @click="toggleCheckbox(optionKey)"></span>
            </label>
            <div class="text" @click.stop="toggleCheckbox(optionKey)">{{ getLabel(optionKey) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { saveToLocalStorage, loadFromLocalStorage } from '../../../utils/formStore';

export default {
  name: "AboutSupsis",
  data() {
    return {
      optionKeys: [
        'socialMediaManagement',
        'aiChatbotAutomation',
        'digitalSolutions',
        'optimizeProcesses',
        'endToEndSolution'
      ],
      options: {
        socialMediaManagement: false,
        aiChatbotAutomation: false,
        digitalSolutions: false,
        optimizeProcesses: false,
        endToEndSolution: false
      }
    };
  },
  created() {
    const saved = loadFromLocalStorage().aboutSupsis || {};
    this.optionKeys.forEach(key => {
      this.options[key] = saved[key] || false;
    });
  },
  watch: {
    options: {
      handler(newVal) {
        if (newVal.endToEndSolution) {
          Object.keys(this.options).forEach(key => {
            if (key !== 'endToEndSolution') {
              this.options[key] = false;
            }
          });
        }
        this.saveSelections();
      },
      deep: true
    }
  },
  methods: {
    toggleCheckbox(optionKey) {
      if (optionKey === 'endToEndSolution') {
        const newState = !this.options[optionKey];
        Object.keys(this.options).forEach(key => {
          this.options[key] = key === 'endToEndSolution' ? newState : false;
        });
      } else {
        if (this.options.endToEndSolution) return;
        this.options[optionKey] = !this.options[optionKey];
      }
      this.saveSelections();
    },
    saveSelections() {
      saveToLocalStorage({ aboutSupsis: this.options });
    },
    getLabel(optionKey) {
      const labels = {
        socialMediaManagement: this.$t("socialMediaManagementText"),
        aiChatbotAutomation: this.$t("aiChatbotAutomationText"),
        digitalSolutions: this.$t("digitalSolutionsText"),
        optimizeProcesses: this.$t("optimizeProcessesText"),
        endToEndSolution: this.$t("endToEndSolutionText")
      };
      return labels[optionKey];
    }
  }
};
</script>


<style lang="scss" scoped>
#AboutSupsis {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    background-image: url("../../../assets/BackgroundOne.png");
    background-repeat: no-repeat;
    background-size: cover;

    .title-text {
        font-family: 'Plus Jakarta Sans', sans-serif;
        text-align: center;

        h1 {
            font-size: 2rem;
            color: #272657;
            font-weight: bold;

            @media (max-width: 768px) {
                font-size: 1.8rem;
            }

            @media (max-width: 480px) {
                font-size: 1.5rem;
            }
        }
    }

    .content {
        display: flex;
        justify-content: center;
        padding: 15px 15px;
        overflow-y: auto;
        height: auto;

        .form-now{
          width: 100%;
          max-width: 600px;
          margin: auto;
          font-family: Arial, sans-serif;
          height: 60vh;

        }

        @media (max-width: 1024px) {
          .about-form{
            height: 50vh !important;
          }
        }


      .about-form {
            padding: 30px;
            width: 40%;
            max-width: 1000px;
            border-radius: 20px;
            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
            height: 50vh;
          background: #fff;
            display: grid;
            grid-template-columns: 1fr;
            gap: 20px;
          overflow: auto;

            @media (max-width: 1024px) {
                width: 60%;
                padding: 25px 30px 25px 30px !important;
                .form-now{
                  height: 48vh !important;
                }
            }

            @media (max-width: 768px) {
                width: 80%;
                padding: 20px;
            }

            @media (max-width: 480px) {
                width: 95%;
                padding: 10px;
                margin: 10px auto;
                max-height: 80vh;

                .card {
                    padding: 12px;
                    margin-bottom: 8px;
                    min-height: auto;

                    &:hover {
                        transform: translateY(-2px) scale(1.01);
                    }

                    .check-box {
                        .checkmark {
                            height: 18px;
                            width: 18px;

                            &::after {
                                left: 5px;
                                top: 2px;
                                width: 5px;
                                height: 8px;
                            }
                        }
                    }

                    .text {
                        font-size: 0.85rem;
                        line-height: 1.3;
                        padding-right: 5px;
                        word-wrap: break-word;
                    }
                }
            }

            .card {
                cursor: pointer;
                display: flex;
                align-items: center;
                border: 1px solid #ccc;
                border-radius: 10px;
                padding: 20px;
                transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                margin-bottom: 10px;

                &:hover {
                    transform: translateY(-5px) scale(1.02);
                    box-shadow: 0 8px 20px rgba(93, 91, 141, 0.15);
                }

                &.disabled {
                    opacity: 0.5;
                    pointer-events: none;
                    background-color: #f0f0f0;
                }

                .check-box {
                    position: relative;
                    margin-right: 10px;
                    display: flex;
                    align-items: center;
                    cursor: pointer;

                    input {
                        position: absolute;
                        opacity: 0;
                        cursor: pointer;

                        &:checked ~ .checkmark {
                            background-color: #5d5b8d;
                            border: 1px solid #5d5b8d;
                        }

                        &:checked ~ .checkmark::after {
                            display: block;
                        }
                    }

                    .checkmark {
                        height: 24px;
                        width: 24px;
                        background-color: #fff;
                        border: 1px solid #ccc;
                        border-radius: 50%;
                        display: inline-block;
                        position: relative;
                        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

                        &::after {
                            content: "";
                            position: absolute;
                            display: none;
                            left: 8px;
                            top: 4px;
                            width: 6px;
                            height: 10px;
                            border: solid #fff;
                            border-width: 0 2px 2px 0;
                            transform: rotate(45deg);
                            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                        }
                    }
                }

                .text {
                    flex: 1;
                    text-align: left;
                    font-family: 'Plus Jakarta Sans', sans-serif;
                    font-size: 1rem;
                    color: #272657;
                }

                &:focus-within {
                    border-color: #5d5b8d;
                }
            }
        }
    }

    .fade-in {
        opacity: 0;
        animation: fadeIn 1.5s ease-out forwards;
    }

    .slide-in {
        opacity: 0;
        animation: slideIn 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;
        &:nth-child(1) { animation-delay: 0.6s; }
        &:nth-child(2) { animation-delay: 0.9s; }
        &:nth-child(3) { animation-delay: 1.2s; }
        &:nth-child(4) { animation-delay: 1.5s; }
        &:nth-child(5) { animation-delay: 1.8s; }
    }

    @keyframes fadeIn {
        0% {
            opacity: 0;
            transform: translateY(-30px);
        }
        30% {
            opacity: 0.3;
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes slideIn {
        0% {
            opacity: 0;
            transform: translateX(-60px) scale(0.9);
        }
        50% {
            opacity: 0.5;
        }
        100% {
            opacity: 1;
            transform: translateX(0) scale(1);
        }
    }
}
</style>